/**
 * check if session storage is supported or not
 * @returns {boolean}
 */
export const isSessionSupported = () => {
   const testKey = 'test',
      storage = window.sessionStorage;
   try {
      storage.removeItem(testKey);
      return true;
   } catch (error) {
      return false;
   }
};

export const getFromSessionStorage = (key: string) => {
   if (!isSessionSupported()) return null;

   try {
      const item = window?.sessionStorage?.getItem(key);
      const val = JSON.parse(item ? item : '');
      return val ? val : null;
   } catch (error) {
      return null;
   }
};

export const addZIndexToAllSteps = () => {
   try {
      const steps = ['Step3_porting', 'Step3', 'Step4', 'Step5', 'Step6']
      const stepSection = document.querySelector(
         '#landing_page_step_section'
      ) as HTMLDivElement;
      let stepSectionChildren = stepSection?.children
      const newAcqStepSectionChildren = steps.map((step) => document.querySelector(`#${step}`));

      if (!stepSectionChildren && !newAcqStepSectionChildren) addZIndexToAllSteps();

      const children = stepSectionChildren ? stepSectionChildren : newAcqStepSectionChildren
      if (stepSection?.style) stepSection.style.zIndex = '100';

      (Array.from(children) as HTMLDivElement[]).forEach(
         (widgetDiv, index) => {
            if (!widgetDiv?.style) return;
            let zIndex = `${100 - index}`;
            if (widgetDiv.id === 'Step3_porting' || widgetDiv.id === 'SKYC_LANDING_PAGE_step3Widget' || widgetDiv.id === 'NEW_ACQ_POSTPAID_SKYC_step3Widget') {
               zIndex = '1001';
            }
            widgetDiv.style.zIndex = zIndex;
         }
      );
   } catch (error) {
      //
   }
};

// "<?xml version="1.0" encoding="UTF-8"?> <PrintLetterBarcodeData simNo="8991101906280709542U" imsiNo=" 404100628070954"/>"

export const getAttributesFromXML = (
   xml: string,
   tagName: string
): Record<string, string> | null => {
   const parser = new DOMParser();
   const replacedString = xml.replace(/&/g, '&amp;');
   const xmlDoc = parser.parseFromString(replacedString, "application/xml");

   const element = xmlDoc.getElementsByTagName(tagName)[0];

   // Return null if the tag is not found
   if (!element) {
      return null;
   }

   const result: Record<string, string> = {};

   // Loop over attributes and add them to the result object
   Array.from(element.attributes).forEach(attr => {
      result[attr.name] = attr.value?.trim();
   });

   return result;
};
